/* 10/2 사장님 「구글이랑 애플에 출시해」 — 플레이 스토어에서 받은 안드로이드 앱(TWA, android/ — androidbrowserhelper billing) 안에서는
   유료 풀이를 구글 플레이 결제로만 판다(사장님 10/1 「구글꺼 쓰자」 · private-review/플레이앱정보/플레이결제-붙이기.md).
   크롬은 플레이 앱 안에서만 getDigitalGoodsService(구글 결제)를 준다 — 보통 크롬 · 사파리 · 아이폰 앱에서는 null 이라 웹 · Apple 결제 그대로.
   ① 서버에 주문(/api/pay/play/start — 값 · 상품 reading_<값> 은 서버가 정한다)
   ② 계정·주문을 연결하는 앱의 Play 결제창(PaymentRequest) → 구매 토큰
   ③ 서버가 구글에 물어 확인 · 소비하고 연다(/api/pay/play/grant — deploy/pay.js 플레이결제)
   결제 뒤 확인 전에 앱이 꺼지면, 다음에 켤 때 남은 구매(listPurchases)를 이 기기에 적어 둔 주문으로 다시 보낸다(3일 안에 소비하지 않으면 구글이 돌려준다).
   coin.js 가 window.BGPLAY 를 쓴다. */
(() => {
  const 방식 = "https://play.google.com/billing", 결제방식 = "https://bamgwabi.com/pay/play/v1", 남김 = "bambee.play.pending", 이어 = "bambee.play.resume";
  let 서비스P = null;
  let 지원P = null;
  // 일정한 내용으로 검사하여 canMakePayment의 서로 다른 질의 횟수 제한에 걸리지 않는다.
  const 지원 = () => (지원P ||= (async () => {
    try { return await new PaymentRequest([{ supportedMethods: 결제방식, data: { bindingVersion: 1 } }], { total: { label: "합계", amount: { currency: "KRW", value: "0" } } }).canMakePayment() === true; }
    catch { 지원P = null; return false; }
  })());
  const 서비스 = () => (서비스P ||= (async () => {
    if (typeof window.getDigitalGoodsService !== "function" || typeof window.PaymentRequest !== "function") return null;
    try { return (await window.getDigitalGoodsService(방식)) || null; } catch { return null; }
  })());
  const 읽기 = (key = 남김) => { try { const o = JSON.parse(localStorage.getItem(key) || "{}"); return o && typeof o === "object" ? o : {}; } catch { return {}; } };
  const 쓰기 = (o, key = 남김) => { try { localStorage.setItem(key, JSON.stringify(o)); } catch { /* 저장이 막히면 이번 확인만 */ } };
  // 10/20 — 낸 주문마다 하나(주문번호를 열쇠로) 적는다. 예전에는 상품(값)마다 하나여서, 확인하지 못한 앞 주문(다른 계정으로 로그인한 뒤 등)이 남으면
  //   같은 값의 다른 풀이 구매가 모두 「이전 결제를 확인 중이에요」로 막혔다(막지 않으면 앞 주문의 복구 정보를 덮어썼다).
  //   이제 막는 것은 같은 풀이(req)의 남은 주문뿐이다 — 같은 상품을 아직 소비하지 않았으면 구글이 결제창에서 막는다. 예전 판이 상품 이름으로 적은 것도 값의 주문번호로 읽는다.
  const 낸주문들 = () => Object.fromEntries(Object.values(읽기()).filter((o) => typeof o?.주문번호 === "string" && o.주문번호).map((o) => [o.주문번호, o]));
  const 적어두기 = (상품, 주문번호, req, accountId, profileId) => {
    let free = null;
    try { const saved = JSON.parse(sessionStorage.getItem("bambee.tarot.resume") || "null"); if (req.questionId === "tarot" && JSON.stringify(saved?.req) === JSON.stringify(req)) free = saved.free; } catch { /* 사주 풀이 */ }
    const o = 낸주문들(); o[주문번호] = { 주문번호, 상품, req, free, accountId, profileId, 때: Date.now() }; 쓰기(o);
  };
  const 지우기 = (주문번호) => { const o = 낸주문들(); if (o[주문번호]) { delete o[주문번호]; 쓰기(o); } };
  const 미구매정리 = async (상품, 주문번호) => {
    if (낸주문들()[주문번호]?.토큰) return;
    try {
      const s = await 서비스(), purchases = await s?.listPurchases();
      if (Array.isArray(purchases) && !purchases.some((p) => p?.itemId === 상품) && !낸주문들()[주문번호]?.토큰) 지우기(주문번호);
    } catch { /* 구매 여부를 확인하지 못했으면 복구 정보를 유지한다. */ }
  };
  const 원 = (p) => {
    const n=Number(p?.value),currency=p?.currency || 'KRW';
    if(!Number.isFinite(n) || !/^[A-Z]{3}$/.test(currency))return null;
    return currency==='KRW' && (!window.BGLANG?.locale || window.BGLANG.locale==='ko') ? `${n.toLocaleString('ko-KR')}원` : new Intl.NumberFormat(window.BGLANG?.locale || navigator.language,{style:'currency',currency,currencyDisplay:currency==='KRW'?'code':'symbol'}).format(n);
  };

  async function 확인(post, 상품, 주문번호, 토큰) {
    const all = 낸주문들(), old = all[주문번호];
    const o = old ? { ...old, 상품, 토큰 } : Object.values(읽기(이어)).find((x) => x.주문번호 === 주문번호);
    // 소비 직후 답을 못 받아도 토큰으로 다시 확인한다(listPurchases 에서는 이미 사라질 수 있다).
    if (old) { all[주문번호] = o; 쓰기(all); }
    const g = await post("/api/pay/play/grant", { 주문번호, 상품, 토큰 });   // post 는 실패하면 던진다(e.끝 — 다시 보내도 소용없음)
    if (o?.req?.questionId) { const r = 읽기(이어); if (!r[o.req.questionId] || Number(r[o.req.questionId].때 || 0) <= Number(o.때 || 0)) { r[o.req.questionId] = o; 쓰기(r, 이어); } }
    지우기(주문번호);
    return g;
  }
  window.BGPLAY = {
    // 플레이 앱 안인가(구글 결제를 쓸 수 있나)
    ready: async () => !!(await 서비스()),
    // 구글이 이 기기에 보일 값(원화 표시) — 못 받으면 null(서버 값을 그대로 보인다)
    price: async (상품) => { const s = await 서비스(); if (!s || !상품) return null; try { const [d] = await s.getDetails([상품]); return 원(d?.price); } catch { return null; } },
    prices: async (ids) => { const s=await 서비스();if(!s)return [];return (await s.getDetails(ids)).map(d=>({id:d.itemId,currency:d.price?.currency,price:Number(d.price?.value),displayPrice:원(d.price)})); },
    // 산다 — { 이미 } 면 이미 산 풀이. 결제창을 닫으면 { 닫음 }. 확인이 늦으면 던진다(남은 구매는 다음에 다시 보낸다)
    async buy(post, req) {
      const same = (o) => JSON.stringify(o?.req) === JSON.stringify(req);
      const mine = () => Object.values(낸주문들()).filter(same);
      const pending = mine().find((o) => o.토큰);
      if (pending) return 확인(post, pending.상품, pending.주문번호, pending.토큰);
      const previous = mine()[0];   // 같은 풀이로 전에 낸 주문은 그 주문으로 다시 연다(서버가 같은 주문을 준다)
      const o = await post("/api/pay/play/start", { req, ...(previous ? { 주문번호: previous.주문번호 } : {}) });
      if (o?.이미) return { 이미: true };
      if (!/^gp[a-f0-9]{32}$/.test(o?.주문번호 || "") || !o?.상품 || !/^[a-f0-9]{64}$/.test(o.accountId || "") || o.profileId !== o.주문번호) throw new Error("지금은 결제할 수 없어요");
      if (!await 지원()) throw new Error("Play 결제를 이용하려면 앱을 최신 버전으로 업데이트해 주세요");
      적어두기(o.상품, o.주문번호, req, o.accountId, o.profileId);
      const pr = new PaymentRequest([{ supportedMethods: 결제방식, data: { sku: o.상품, accountId: o.accountId, profileId: o.profileId, locale: window.BGLANG?.locale || "ko" } }], { total: { label: window.BGLANG?.t("합계") || "합계", amount: { currency: "KRW", value: "0" } } });
      let res;
      try { res = await pr.show(); } catch (e) { await 미구매정리(o.상품, o.주문번호); if (e?.name === "AbortError") return { 닫음: true }; throw e; }
      const 토큰 = res?.details?.purchaseToken || res?.details?.token;
      if (!토큰) { try { await res.complete("fail"); } catch { /* 이미 닫힘 */ } await 미구매정리(o.상품, o.주문번호); throw new Error("결제 확인에 실패했어요. 잠시 뒤에 다시 해 주세요"); }
      try { const g = await 확인(post, o.상품, o.주문번호, 토큰); try { await res.complete("success"); } catch { /* 이미 닫힘 */ } return g; }
      catch (e) { try { await res.complete(e?.끝 ? "fail" : "unknown"); } catch { /* 이미 닫힘 */ } if (e?.끝) 지우기(o.주문번호); throw e; }
    },
    // 앱을 켤 때 — 결제는 됐는데 서버 확인을 못 한 구매를 다시 보낸다. 하나라도 열면 true
    async recover(post, q) {
      const s = await 서비스(); if (!s) return false;
      let 열림 = false;
      try {
        let 구매 = null; try { 구매 = await s.listPurchases(); } catch { /* 적어 둔 토큰으로 확인 */ }
        const 이전 = q && 읽기(이어)[q];
        const 남은 = [...(이전 ? [이전] : []), ...Object.values(낸주문들())];
        const 확인한 = new Set();
        await Promise.all(남은.map(async (주문) => {
          const 상품 = 주문?.상품, 토큰 = 주문?.토큰 || 구매?.find((p) => p?.itemId === 상품)?.purchaseToken;
          if (!토큰 && Array.isArray(구매) && !구매.some((p) => p?.itemId === 상품) && !낸주문들()[주문?.주문번호]?.토큰) 지우기(주문?.주문번호);
          if (!상품 || !토큰 || !주문?.주문번호) return;
          if (확인한.has(주문.주문번호)) return;
          확인한.add(주문.주문번호);
          try { const g = await 확인(post, 상품, 주문.주문번호, 토큰); if (g?.ok) 열림 = true; } catch (e) {
            if (e?.끝) { 지우기(주문.주문번호); const r = 읽기(이어); if (r[주문.req?.questionId]?.주문번호 === 주문.주문번호) { delete r[주문.req.questionId]; 쓰기(r, 이어); } }
            // 10/8 점검 — 이 기기에 적어 두지 않은(구글 구매 목록에서 찾은) 토큰을 이 주문 칸에 먼저 적어 두었다가 403(다른 주문의 결제 — 끝 아님)이면
            //   그 칸이 「이전 결제를 확인 중이에요」로 막혔다(buy). 확인 앞에 따로 적던 줄은 지우고(확인() 이 같은 것을 적는다 — 소비 뒤 답을 못 받을 때 쓴다), 403 이면 그 토큰을 칸에서 뺀다
            else if (e?.status === 403 && !주문.토큰) { const all = 낸주문들(); if (all[주문.주문번호]?.토큰 === 토큰) { delete all[주문.주문번호].토큰; 쓰기(all); } }
          }
        }));
      } catch { /* 다음에 */ }
      return 열림;
    },
    resume: (q) => Object.values(읽기()).find((o) => o.req?.questionId === q) || 읽기(이어)[q] || null,
  };
})();
